var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.591,38.966c0-9.7-7.892-17.591-17.591-17.591c-9.7,0-17.591,7.891-17.591,17.591c0,6.252,3.288,11.738,8.216,14.858 v19.193c0,0.809,0.487,1.538,1.235,1.848c0.745,0.31,1.607,0.139,2.179-0.434L48,68.471l5.961,5.961 c0.383,0.383,0.894,0.586,1.414,0.586c0.258,0,0.518-0.05,0.766-0.152c0.747-0.31,1.234-1.039,1.234-1.848V53.824 C62.303,50.703,65.591,45.218,65.591,38.966z M53.375,68.189l-3.961-3.961c-0.781-0.781-2.048-0.781-2.828,0l-3.961,3.961V55.71 c1.696,0.546,3.5,0.847,5.375,0.847s3.679-0.301,5.375-0.847V68.189z M48,52.557c-7.494,0-13.591-6.097-13.591-13.591 S40.506,25.375,48,25.375s13.591,6.097,13.591,13.591S55.494,52.557,48,52.557z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.4b6adf65ff23c98995818c68a352de15.svg";
export { ForwardRef as ReactComponent };